import axios from "axios";
import qs from "qs";
import { Endpoints } from "../API/Endpoints";
import { FIAT_API_KEY, FIAT_API_URL, FIAT_TENANT_KEY } from "../config";

const createFiatHeaders = () => {
  const headers = {
    Accept: "application/json",
    "X-User-Agent": "valut-ib",
  };

  if (FIAT_API_KEY) {
    headers["X-Api-key"] = FIAT_API_KEY;
  }

  if (FIAT_TENANT_KEY) {
    headers["X-Tenant-Key"] = FIAT_TENANT_KEY;
  }

  return headers;
};

export const fetchMarketQuotes = (
  currencies = "USD,EUR,PYG,JPY",
  source = "auto"
) => {
  const query = qs.stringify({ currencies, source }, { addQueryPrefix: true });
  const url = `${FIAT_API_URL}${Endpoints.GET.fiatMarketQuotes}${query}`;

  return axios.get(url, { headers: createFiatHeaders() });
};
